import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import DraftSetup from '../-components/draft/DraftSetup';
import RunningView from '../-components/phase-views/RunningView';
import StepPlaceholder from '../-components/StepPlaceholder';
import { useStudyContext } from '../-components/study-context';

function SimulateRoute() {
  const { t } = useTranslation();
  const ctx = useStudyContext();
  const { study, designPoints, geometries } = ctx;

  if (study.status === 'draft') {
    return (
      <div className="h-full overflow-hidden">
        <DraftSetup study={study} geometries={geometries} section="simulate" />
      </div>
    );
  }

  // Running shows the live board + DP inspector; failed / cancelled studies are
  // pinned to this step too (see statusToJourneyStep) so the user can inspect
  // residuals + decoded errors instead of hitting a locked placeholder.
  if (
    study.status === 'running' ||
    study.status === 'failed' ||
    study.status === 'cancelled'
  ) {
    return (
      <div className="h-full overflow-y-auto bg-muted/30 p-6">
        <RunningView
          study={study}
          designPoints={designPoints}
          geometries={geometries}
          selectedDpId={ctx.selectedDpId}
          detailTab={ctx.detailTab}
          onSelectDp={ctx.onSelectDp}
        />
      </div>
    );
  }

  if (
    study.status === 'preprocessing' ||
    study.status === 'awaiting_user_meshing' ||
    study.status === 'awaiting_bc_review'
  ) {
    return (
      <StepPlaceholder
        title={t('simopsRoutes.simulate.notYetTitle')}
        message={t('simopsRoutes.simulate.notYetMessage')}
      />
    );
  }

  return (
    <StepPlaceholder
      title={t('simopsRoutes.simulate.completeTitle')}
      message={t('simopsRoutes.simulate.completeMessage')}
    />
  );
}

export const Route = createFileRoute('/_app/simops/$studyId/simulate')({
  component: SimulateRoute,
});
